export const Loader = () => (
    <div className="flex justify-center items-center fixed inset-0 w-screen h-screen bg-black bg-opacity-95 z-50">
        <div className="w-16 h-16 border-t-4 border-purple-500 border-solid rounded-full animate-spin"></div>
    </div>
);
